import { STATES } from '@js/constants/options';

import { sanitize } from './search';
import filled from './filled';

export const BOOLEANS = [true, 'true', false, 'false'];

const SEARCHABLE = [STATES];

export function sort(a, b) {
  return sanitize(a.label).localeCompare(sanitize(b.label));
}

export function booleanSort(a) {
  return a.value ? 1 : -1;
}

export default function optionize(option) {
  let label;
  let value;
  let searchable;

  if (typeof option !== 'object') {
    label = String(option);
  } else {
    label = filled(option.label) ? option.label : option.name;
  }

  if (filled(option.credere_identifier)) {
    value = option.credere_identifier;
  } else if (filled(option.value)) {
    value = option.value;
  } else {
    value = option.id || option.identifier || label;
  }

  SEARCHABLE.some((i) => {
    searchable = i.find((j) => [j.label, j.name].includes(label))?.value;

    return filled(searchable);
  });

  return {
    label,
    value: String(value),
    searchable,
  };
}
